import React from 'react';
interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  progress: number;
}
export const StepIndicator: React.FC<StepIndicatorProps> = ({
  currentStep,
  totalSteps,
  progress
}) => {
  return <div className="mb-6" data-id="element-796">
      <div className="flex justify-between items-center mb-2" data-id="element-797">
        <span className="text-white/80 text-sm" data-id="element-798">
          Stap {currentStep} van {totalSteps}
        </span>
        <span className="text-white/80 text-sm" data-id="element-799">{progress}% voltooid</span>
      </div>
      <div className="w-full h-2 bg-white/10 rounded-full overflow-hidden" data-id="element-800">
        <div className="h-full bg-[#CDA735] transition-all duration-500 ease-out" style={{
        width: `${progress}%`
      }} data-id="element-801"></div>
      </div>
    </div>;
};